import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import EventEmitter from 'eventemitter3';
import getManager from './getManager';
import setField from '../../utils/setField';
var StateManager = function (_EventEmitter) {
  function StateManager(_ref) {
    var _this;
    var instanceId = _ref.instanceId,
      pathToData = _ref.pathToData;
    _classCallCheck(this, StateManager);
    _this = _callSuper(this, StateManager);
    _defineProperty(_this, "instanceId", null);
    _defineProperty(_this, "context", null);
    _defineProperty(_this, "pathToData", null);
    _defineProperty(_this, "initialize", function (context) {
      if (context) {
        _this.context = context;
        context.managers = context.managers || [];
        if (!context.managers.find(function (instance) {
          return instance.instanceId === _this.instanceId;
        })) {
          context.managers.push(_this);
        } else {
          console.warn("The manager with id: ".concat(_this.instanceId, " is already registered to this context"));
        }
        _this.initializeState();
      }
    });
    _defineProperty(_this, "initializeState", function () {});
    _defineProperty(_this, "getSerializableData", function () {
      return {};
    });
    _defineProperty(_this, "getSerializedScript", function () {
      return '';
    });
    _defineProperty(_this, "getHeadScriptContent", function () {
      return "\n      window.".concat(_this.pathToData, " = ").concat(JSON.stringify(_this.getSerializableData()), ";\n      ").concat(_this.getSerializedScript(), "\n    ");
    });
    _defineProperty(_this, "getHeadScript", function () {
      return "\n      <script>\n        ".concat(_this.getHeadScriptContent(), "\n      </script>\n    ");
    });
    _this.instanceId = instanceId;
    _this.pathToData = pathToData;
    return _this;
  }
  _inherits(StateManager, _EventEmitter);
  return _createClass(StateManager);
}(EventEmitter);
_defineProperty(StateManager, "AppState", 'AppState');
_defineProperty(StateManager, "DataLayer", 'DataLayer');
_defineProperty(StateManager, "getInstance", function (Type, context) {
  if (!context) {
    return null;
  }
  var manager = getManager(Type.InstanceId, context);
  if (!manager) {
    manager = new Type(context);
    manager.initialize(context);
    if (typeof window !== 'undefined') {
      setField(window, "KBB.Blueprint.".concat(Type.InstanceId), manager);
    }
  }
  return manager;
});
export { StateManager as default };